import EmblaCarousel, { type EmblaOptionsType } from "embla-carousel"
import { addPrevNextBtnsClickHandlers } from "./modules/embla-carousel-arrow-buttons";
declare function gtag(...args: any[]): void;

(function() {  
  const loadEmblaCarousel = () => {
    const OPTIONS: EmblaOptionsType = { loop: true, slidesToScroll: 'auto' }

    const emblaNode = document.querySelector('.embla')
    if(!emblaNode) return;

    const viewportNode = emblaNode.querySelector('.embla__viewport') as HTMLElement
    const prevBtnNode = emblaNode.querySelector('.embla__button--prev') as HTMLElement
    const nextBtnNode = emblaNode.querySelector('.embla__button--next') as HTMLElement
    if(!viewportNode || !prevBtnNode || !nextBtnNode) return;

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS)
    
    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtnNode,
      nextBtnNode
    )
    
    emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
  }

  const onFormSent = (event: Event) => {
    const detail = (event as CustomEvent).detail;
    if (!detail || !detail.unitTag) return;

    gtag('event', 'form_submission', {
      'event_category': 'Contact Form',
      'event_label': 'CF7 - Success - ' + detail.contactFormId,
      'value': 1,
      'form_id': detail.contactFormId
    });
  }

  window.addEventListener('load', () => {
    loadEmblaCarousel();
  });

  document.addEventListener('wpcf7mailsent', onFormSent);
})();